var React = require('react');

function Success (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.5","cx":"50","cy":"50","r":"50","fill":"#CEFBE0","key":0}),React.createElement("g",{"clipPath":"url(#clip0_15_7438)","key":1},React.createElement("path",{"d":"M38.333 49.9998L46.6663 58.3332L63.333 41.6665","stroke":"#0DB350","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round"})),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0_15_7438"},React.createElement("rect",{"width":"40","height":"40","fill":"white","transform":"translate(30 30)"})))]);
}

Success.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = Success;

Success.default = Success;
